
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Redirect, useParams } from 'react-router';

import { useStore } from 'stores';
import * as paths from 'app-router/paths';
import Loading from 'components/Loading';
import { ErrorMessage } from 'components/Message';
import { LabeledIcon, ReloadIcon, RequestersIcon } from 'components/Icon';
import { FormCard } from 'components/Card';

import { EditForm, UserInputDictionary } from './EditForm';

export const Page: React.FC = observer(() =>
{
  const [needToLoad, setNeedToLoad] = useState(true);
  const { requesterToken } = useParams<{requesterToken: string}>();
  const { uiStore, requesterStore } = useStore();
  const [userInput, setUserInput] = useState<UserInputDictionary>({});

  const reloadDataHandler = async () => await requesterStore.getByTokenAsync(requesterToken);

  useEffect(() =>
  {
    if (!requesterStore.requester.data || requesterStore.requester.data.token !== requesterToken)
    {
      requesterStore.getByTokenAsync(requesterToken);
    }
    setNeedToLoad(prev => false);
  }, [requesterToken, requesterStore, setNeedToLoad]);

  return (
    <article className="page audience requester-edit">
      <FormCard>
      {
        requesterStore.requester.isLoading || needToLoad
        ? <><h1>{uiStore.labels.common.loading}</h1><Loading /></>
        : requesterStore.requester.isError
          ? <>
              <h1>{uiStore.labels.common.anErrorOccured}</h1>
              <ErrorMessage>{requesterStore.requester.errorMessage} <button onClick={reloadDataHandler}><LabeledIcon label={uiStore.labels.common.tryAgain}><ReloadIcon/></LabeledIcon></button></ErrorMessage>
            </>
          : requesterStore.requester.data
            ? <>
                <h1><RequestersIcon />{uiStore.labels.pages.audience.pages.requesterEdit.title.apply({requesterName: requesterStore.requester.data.name})}</h1>
                {requesterStore.requester.errorMessage ? <ErrorMessage>{requesterStore.requester.errorMessage}</ErrorMessage> : null}
                <EditForm userInput={userInput} saveUserInput={(input) => setUserInput(prev => input)} requester={requesterStore.requester.data} />
              </>
            : <Redirect to={paths.buildNotFoundPath()} />
      }
      </FormCard>
    </article>
  );
});